import { AxiosResponseHeaders } from 'axios';
import { CardTransactionsDownloadResponseBody, CardTransactionsDownloadResponseDTO } from '../entities/CardTransaction';

export const CardTransactionsDownloadResponseDTOToCardTransactionsDownloadAdapter = (
  data: CardTransactionsDownloadResponseDTO,
  header?: AxiosResponseHeaders,
): CardTransactionsDownloadResponseBody => {
  if (!data.body) {
    throw new Error();
  }

  return data.body;
};
